
/* injects from baggage-loader */

'use strict';

import LearnComponent from './learn.component';
import '../home/home.scss';

const LearnPageModule = angular.module('learn-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('learn', {
        url: '/learn',
        component: 'learn',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('learn', new LearnComponent());

export default LearnPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/learn/learn.module.js